import { useRef, useEffect } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import * as clientMedia from '../../../../lib/client-media';

// 1920x1080
// 1080 - 40 顶栏 - 40 任务栏 = 1000
// 视频大小 960 x 720

/**
 * height:   784  1024
 *
 *
 *
 * width:
 * 1280
 * 12+348+12+536+12+348+12
 *
 * 1600
 * 12+456+12+640+12+456+12
 *
 * 1920
 * 12+456+12+960+12+456+12
 *
 * */

//
//
//
//

const bodyHeight = 1024;

const GlobalStyle = createGlobalStyle`
  #page,
  #__next,
  .layout,
  .layout-bg {
    position: relative;
    //height:100vh;
    //height: ${bodyHeight}px; // 1020 48
    //width:100vw;
    //width: 1920px;
    padding: 0;
    margin: 0 auto;
    box-sizing: border-box;
    //background-color:transparent;
    color: #fff;
    //overflow: hidden;
    background: #272c32;
  }

  #__next{
    height: 100%;
  }

  .page-login {
    #page,
    #__next {
      width: auto;
      height: auto;
    }

    background: transparent;
  }

  .page-live {
    #page {
      //background:none;
      min-width: auto!important;
    }

  }

  html {
    background: #272c32 !important;
  }

  #page{
    overflow: auto;
    width: 100vw;
    height: 100vh;
    min-width: auto;
    padding: 0!important;
    &::-webkit-scrollbar {
      background: transparent;
      width: 10px;
      height: 10px;
    }
  }

  #im_app {
    position: absolute;
    z-index: 4000;
  }

  #j_fixedbar {
    display: none;
  }

  ::-webkit-scrollbar {
    background: transparent;
    width: 6px;
    height: 6px;
  }

  ::-webkit-scrollbar-corner {
    background: transparent;
  }

  /* 滚动槽--外层轨道 */

  ::-webkit-scrollbar-track {
    background: none;
  }

  /* 内层轨道（不包含滚动块部分） */

  ::-webkit-scrollbar-track-piece {
    opacity: 0; /* 透明度设置为全透明，使得滚动条背景色为网页颜色 */
  }

  /* 滚动条滑块 */

  ::-webkit-scrollbar-thumb {
    border-radius: 3px;

    //background: none;
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {

    background: rgba(136, 136, 136, 0.5);
  }

  //:active::-webkit-scrollbar-thumb {
  //  background: rgba(255, 255, 255, 0.7);
  //}

  .darkScrollBar::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.3);
  }

  //.darkScrollBar:active::-webkit-scrollbar-thumb {
  //  background: rgba(0, 0, 0, 0.5);
  //}
  .lightScrollBar::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.5);
  }

  //.lightScrollBar:active::-webkit-scrollbar-thumb {
  //  background: rgba(255, 255, 255, 0.7);
  //}

`;

//  988  743
//  466 100,  1454 843
const Page = styled.div.attrs(() => {
  return {
    className: 'layout',
  };
})`
  display: flex;
  flex-wrap: nowrap;
  box-sizing: border-box;
  padding: 48px 12px 12px !important;
  width: 1920px;
  min-height: 1024px;
  height: 100%;
  //max-height: 1036px;

  position: relative;
  //margin-top: -${bodyHeight}px !important;

  .mc-font {
    font-size: inherit;
  }
  //background-color: #272c32 !important;
`;

// 960 * 720  442+24

const PageMedia = styled(Page)`
  // ${clientMedia.media1080} {
  //   width: 1080px;
  //   //min-height: 720px;
  //   min-height: 862px;
  // }
  ${clientMedia.media1280} {
    width: 1280px;
    min-height: 816px;
  }
  ${clientMedia.media1600} {
    width: 1600px;
    min-height: 816px;
  }
  ${clientMedia.media1920} {
    width: 1920px;
    min-height: 1024px;
  }
`;

const video = {
  x: 456 + 24,
  y: 64,
  width: 960,
  height: 720,
};

const hostVideo = {
  x: 456 + 24 + 12,
  y: 64 + 720 + 12 + 12,
  width: 166,
  height: 166,
};

const MainLeft = styled.div`
  position: relative;
  flex: 1;
  display: flex;
  width: 1396px;
  height: 100%;
  box-sizing: border-box;
  padding-bottom: 52px;
`;

const Left = styled.div`
  flex: 1;
  width: 456px;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const LeftMedia = styled(Left)`
  // ${clientMedia.media1080} {
  //   width: 348px;
  // }
  ${clientMedia.media1280} {
    width: 348px;
  }
`;

const Middle = styled.div`
  width: 960px;
  height: 100%;
  margin: 0 12px;

  display: flex;
  flex-direction: column;
`;

const MiddleMedia = styled(Middle)`
  justify-content: space-between;
  // ${clientMedia.media1080} {
  //   width: 336px;
  // }
  ${clientMedia.media1280} {
    width: 536px;
  }
  ${clientMedia.media1600} {
    width: 640px;
  }
`;

const Right = styled.div`
  width: 456px;
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const RightMedia = styled(Right)`
  // ${clientMedia.media1080} {
  //   width: 348px;
  // }
  ${clientMedia.media1280} {
    width: 348px;
  }
`;

const Loading = styled.div`
  padding-top: 300px;
`;

export {
  GlobalStyle,
  Page,
  PageMedia,
  MainLeft,
  Left,
  LeftMedia,
  Middle,
  MiddleMedia,
  Right,
  RightMedia,
  Loading,
};
